<template>
  <div
    class="b-leaseitnow-compare-accordion-equipment"
    :class="{ 'is-active': isActive }">
    <div class="row gx-5">
      <div class="col-3">
        <div
          class="b-leaseitnow-compare-accordion-equipment__header"
          @click="onClickHeader">
          <i class="icon-arrow-dropdown-down"></i>
          <span>{{ title }}</span>
        </div>
      </div>

      <!-- col -->
      <div v-for="item in records" :key="item" v-auto-animate class="col-3">
        <ul v-if="isActive" class="is-checked">
          <li v-for="(spec, index) in getSpecs(item)" :key="index">
            {{ spec }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    records: {
      required: false,
      type: Array,
      default: () => [],
    },
    isActiveProp: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return { isActive: false }
  },
  watch: {
    isActiveProp(newValue) {
      this.isActive = newValue
    },
  },
  mounted() {
    this.isActive = this.isActiveProp
  },

  methods: {
    getSpecs(item) {
      const group = item.sorted_specs[this.groupId]

      if (!group) {
        return []
      }

      return group.slice(1).map((x) => x.spec_name)
    },
    onClickHeader() {
      this.isActive = !this.isActive
    },
  },
}
</script>
